var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "must-have-exactly-one-root-element" },
    [
      _c("header-profil", {
        attrs: { profil: _vm.profil },
        on: { updateProfil: _vm.emitUpdateProfil }
      }),
      _vm._v(" "),
      _c("main", { staticClass: "profileDashboard --statistics" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "row" },
            [
              _c("menu-profil", {
                attrs: { profil: _vm.profil, spravy: _vm.spravy }
              }),
              _vm._v(" "),
              _vm.profil.pouzivatel_id
                ? _c(
                    "div",
                    { staticClass: "col-xs-12 col-md-12 col-lg-8 col-xl-9" },
                    [
                      _c("h2", [_vm._v("Štatistiky")]),
                      _vm._v(" "),
                      _vm.responseText != ""
                        ? _c(
                            "div",
                            {
                              class: "alert alert-" + _vm.responseType,
                              attrs: { role: "alert" }
                            },
                            [
                              _c("span", {
                                class: "icon --" + _vm.responseType
                              }),
                              _vm._v(
                                _vm._s(_vm.responseText) +
                                  "\n                    "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "d-md-none mb-4" }, [
                        _c(
                          "select",
                          {
                            staticClass: "custom-select",
                            attrs: { id: "inputGroupSelect01" },
                            on: {
                              change: function($event) {
                                return _vm.onChange($event.target.value)
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "0" } }, [
                              _vm._v("Najviac zadaných EAN kódov celkom")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "1" } }, [
                              _vm._v("Najviac zadaných rôznych EAN kódov")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "2" } }, [
                              _vm._v("Najšťastnejšia kravička")
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          staticClass: "nav nav-tabs d-none d-md-flex",
                          attrs: { id: "myTab", role: "tablist" }
                        },
                        [
                          _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                class:
                                  "nav-link show" +
                                  [_vm.tab == 0 ? " active" : ""],
                                on: {
                                  click: function($event) {
                                    _vm.changeStatistics(
                                      "pocet_ean_aktualny_mesiac"
                                    )
                                    _vm.selected(0)
                                  }
                                }
                              },
                              [
                                _vm._v("Najviac zadaných"),
                                _c("br"),
                                _vm._v(" EAN kódov celkom")
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                class:
                                  "nav-link show" +
                                  [_vm.tab == 1 ? " active" : ""],
                                on: {
                                  click: function($event) {
                                    _vm.changeStatistics(
                                      "pocet_roznych_ean_aktualny_mesiac"
                                    )
                                    _vm.selected(1)
                                  }
                                }
                              },
                              [
                                _vm._v("Najviac zadaných"),
                                _c("br"),
                                _vm._v(" rôznych EAN kódov")
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", { staticClass: "nav-item" }, [
                            _c(
                              "a",
                              {
                                class:
                                  "nav-link show" +
                                  [_vm.tab == 2 ? " active" : ""],
                                on: {
                                  click: function($event) {
                                    _vm.changeCowStatistics(
                                      "stastie_aktualny_mesiac"
                                    )
                                    _vm.selected(2)
                                  }
                                }
                              },
                              [
                                _vm._v("Najšťastnejšia"),
                                _c("br"),
                                _vm._v(" kravička")
                              ]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "tab-content",
                          attrs: { id: "myTabContent" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "tab-pane fade show active",
                              attrs: {
                                id: "najviacEan",
                                role: "tabpanel",
                                "aria-labelledby": "najviacEan-tab"
                              }
                            },
                            [
                              _vm.tab == 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "row align-items-center mb-3"
                                    },
                                    [
                                      _vm._m(0),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-4 text-left text-md-right"
                                        },
                                        [
                                          _c(
                                            "select",
                                            {
                                              staticClass: "custom-select",
                                              attrs: { id: "si" },
                                              on: {
                                                change: function($event) {
                                                  return _vm.changeStatistics(
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value:
                                                      "pocet_ean_aktualny_mesiac"
                                                  }
                                                },
                                                [_vm._v("Aktuálny mesiac")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value:
                                                      "pocet_ean_minuly_mesiac"
                                                  }
                                                },
                                                [_vm._v("Minulý mesiac")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value:
                                                      "pocet_ean_predminuly_mesiac"
                                                  }
                                                },
                                                [_vm._v("Predminulý mesiac")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm.tab == 1
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "row align-items-center mb-3"
                                    },
                                    [
                                      _vm._m(1),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-4 text-left text-md-right"
                                        },
                                        [
                                          _c(
                                            "select",
                                            {
                                              staticClass: "custom-select",
                                              attrs: { id: "si" },
                                              on: {
                                                change: function($event) {
                                                  return _vm.changeStatistics(
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value:
                                                      "pocet_roznych_ean_aktualny_mesiac"
                                                  }
                                                },
                                                [_vm._v("Aktuálny mesiac")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value:
                                                      "pocet_roznych_ean_minuly_mesiac"
                                                  }
                                                },
                                                [_vm._v("Minulý mesiac")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value:
                                                      "pocet_roznych_ean_predminuly_mesiac"
                                                  }
                                                },
                                                [_vm._v("Predminulý mesiac")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass: "row align-items-center mb-3"
                                    },
                                    [
                                      _vm._m(2),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-4 text-left text-md-right"
                                        },
                                        [
                                          _c(
                                            "select",
                                            {
                                              staticClass: "custom-select",
                                              attrs: { id: "si" },
                                              on: {
                                                change: function($event) {
                                                  return _vm.changeCowStatistics(
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value:
                                                      "stastie_aktualny_mesiac"
                                                  }
                                                },
                                                [_vm._v("Aktuálny mesiac")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value:
                                                      "stastie_minuly_mesiac"
                                                  }
                                                },
                                                [_vm._v("Minulý mesiac")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value:
                                                      "stastie_predminuly_mesiac"
                                                  }
                                                },
                                                [_vm._v("Predminulý mesiac")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c(
                                    "table",
                                    { staticClass: "statisticsTable" },
                                    [
                                      _c("thead", [
                                        _vm.tab != 2
                                          ? _c("tr", [
                                              _c("th", [_vm._v("#")]),
                                              _vm._v(" "),
                                              _c("th", [_vm._v("Hráč")]),
                                              _vm._v(" "),
                                              _c(
                                                "th",
                                                { staticClass: "text-right" },
                                                [_vm._v("Počet ean kódov")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "th",
                                                { staticClass: "text-right" },
                                                [_vm._v("Počet kravičiek")]
                                              )
                                            ])
                                          : _c("tr", [
                                              _c("th", [_vm._v("#")]),
                                              _vm._v(" "),
                                              _c("th", [_vm._v("Hráč")]),
                                              _vm._v(" "),
                                              _c(
                                                "th",
                                                { staticClass: "text-right" },
                                                [_vm._v("Kravička")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "th",
                                                { staticClass: "text-right" },
                                                [_vm._v("Priemerné šťastie")]
                                              )
                                            ])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "tbody",
                                        _vm._l(_vm.statistiky, function(
                                          item,
                                          index
                                        ) {
                                          return _vm.pouzivatel_statistiky
                                            ? _c("tr", [
                                                _c("td", [
                                                  _vm._v(_vm._s(index + 1))
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "name" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.pouzivatel_meno
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "text-right" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item[_vm.column])
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "count-cows text-right"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.pocet_kraviciek
                                                      )
                                                    )
                                                  ]
                                                )
                                              ])
                                            : _c("tr", [
                                                _c("td", [
                                                  _vm._v(_vm._s(index + 1))
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "name" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.pouzivatel_meno
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  { staticClass: "text-right" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.kravicka_meno)
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "count-cows text-right"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item[_vm.column])
                                                    )
                                                  ]
                                                )
                                              ])
                                        }),
                                        0
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8" }, [
      _c("h4", { staticClass: "mb-2 mb-md-0" }, [
        _vm._v("Najviac zadaných EAN kódov celkom")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8" }, [
      _c("h4", { staticClass: "mb-2 mb-md-0" }, [
        _vm._v("Najviac zadaných rôznych EAN kódov")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-8" }, [
      _c("h4", { staticClass: "mb-2 mb-md-0" }, [
        _vm._v("Najšťastnejšia kravička")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }